import { render, staticRenderFns } from "./Foundation.vue?vue&type=template&id=7704b2a6&scoped=true"
import script from "./Foundation.vue?vue&type=script&lang=js"
export * from "./Foundation.vue?vue&type=script&lang=js"
import style0 from "./Foundation.vue?vue&type=style&index=0&id=7704b2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7704b2a6",
  null
  
)

export default component.exports